exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".system-config-detail .logo-uploader[data-v-4f7b96a8]  .el-upload-dragger{width:100px;height:100px}", ""]);

// exports
